import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedAppModule } from '../app.module.shared';
import { BubbleEditorComponent } from './bubble.editor/bubble.editor.component';
import { PoolStudioRoutingModule } from './poolstudio.routing.module';

@NgModule({
    imports: [
        CommonModule,
        SharedAppModule,
        PoolStudioRoutingModule
    ],
    declarations: [
        BubbleEditorComponent
    ]
})
export class PoolStudioModule { }
